module.exports = __webpack_public_path__ + "img/defaultProductIco.2e906398.png";